import * as RadixPopover from '@radix-ui/react-popover';

export const Combobox = RadixPopover.Root;
